import React from 'react';
import { Box } from '@zillow/constellation';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import { FieldConfig } from './LoanComparison.utils.js';
import { LOAN_PROGRAMS } from '../../utils/zhl-calculator.js';
import { omitUndefined } from '../../utils/lodash.js';
import LoanComparisonFields from './LoanComparisonFields.js';
import { RFC_2822_MONTHS } from '../AmortizationCalculator/AmortizationCalculator.utils.js';

var LoanComparisonCalculator = function LoanComparisonCalculator(_ref) {
  var _Object$assign;
  var defaultValues = _ref.defaultValues,
    editorMode = _ref.editorMode;
  var finalDefaultValues = Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.typeOneLoanAmount.name] = '300000', _Object$assign[FieldConfig.typeOneLoanTerm.name] = LOAN_PROGRAMS.fixed30Year, _Object$assign[FieldConfig.typeOneInterestRate.name] = '4.17', _Object$assign[FieldConfig.typeOneLoanStartMonth.name] = RFC_2822_MONTHS[new Date().getMonth()], _Object$assign[FieldConfig.typeOneLoanStartYear.name] = new Date().getFullYear(), _Object$assign[FieldConfig.typeTwoLoanAmount.name] = '300000', _Object$assign[FieldConfig.typeTwoLoanTerm.name] = LOAN_PROGRAMS.fixed30Year, _Object$assign[FieldConfig.typeTwoInterestRate.name] = '4.17', _Object$assign[FieldConfig.typeTwoLoanStartMonth.name] = RFC_2822_MONTHS[new Date().getMonth()], _Object$assign[FieldConfig.typeTwoLoanStartYear.name] = new Date().getFullYear(), _Object$assign[FieldConfig.typeThreeLoanAmount.name] = '300000', _Object$assign[FieldConfig.typeThreeLoanTerm.name] = LOAN_PROGRAMS.fixed30Year, _Object$assign[FieldConfig.typeThreeInterestRate.name] = '4.17', _Object$assign[FieldConfig.typeThreeLoanStartMonth.name] = RFC_2822_MONTHS[new Date().getMonth()], _Object$assign[FieldConfig.typeThreeLoanStartYear.name] = new Date().getFullYear(), _Object$assign), omitUndefined(defaultValues));
  return /*#__PURE__*/React.createElement(Box, {
    as: CalculatorForm,
    sx: {
      display: 'flex',
      flexDirection: 'column'
    },
    fieldStorageKey: "LoanComparisonCalculatorFields",
    defaultValues: finalDefaultValues,
    editorMode: editorMode
  }, /*#__PURE__*/React.createElement(LoanComparisonFields, null));
};
var LoanComparisonCalculator$1 = LoanComparisonCalculator;

export { LoanComparisonCalculator$1 as default };
